import { StyleRulesCallback, Theme, withStyles, WithStyles } from '@material-ui/core';
import * as React from 'react';
import TopBar from './TopBar';
import { WithChildren } from '../shared/WithChildren';
import YScrollable from './YScrollable';
import { Languages } from '../shared/language/Language';
import bgImage from 'shared/background.jpg';
import { BpM } from '../shared/brakepoints';

type CssClasses = 'layout' | 'mainPage' | 'content' | 'bar';
const styles: StyleRulesCallback<CssClasses> = (theme: Theme) => ({
  layout: {
    flexGrow: 1,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.secondary.main,
  },
  bar: {
    zIndex: 5000,
    backgroundColor: '#FFFFFF',
    'box-shadow': '0px 3px 18px 0px rgba(0,0,0,0.37)',
  },
  content: {
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    background: `url(${bgImage}) no-repeat center center fixed`,
    backgroundSize: 'cover',
  },
  mainPage: {},
});

interface Props {
  onLanguageChange: (language: Languages) => any;
}

const Layout = ({ classes, children, onLanguageChange }: Props & WithChildren & WithStyles<CssClasses>) => (
  <div className={classes.layout}>
    <div className={classes.bar}>
      <TopBar onLanguageChange={onLanguageChange} />
    </div>
    <YScrollable padding={true} className={classes.content}>
      {children}
    </YScrollable>
  </div>
);

export default withStyles(styles)(Layout);



// WEBPACK FOOTER //
// ./src/components/Layout.tsx